export default "__VITE_ASSET__BTTFLJ9W__"